// Converted to lazy loading
const partnersIndex = () => import('@/pages/partners/partners/index.vue')
const partnersForm = () => import('@/pages/partners/partners/form.vue')
const partnersShow = () => import('@/pages/partners/partners/show.vue')

const partnersDepositsIndex = () => import('@/pages/partners/partnersDeposits/index.vue')
const partnersDepositsForm = () => import('@/pages/partners/partnersDeposits/form.vue')
const partnersDepositsShow = () => import('@/pages/partners/partnersDeposits/show.vue')

const partnersWithdrawalsIndex = () => import('@/pages/partners/partnersWithdrawals/index.vue')
const partnersWithdrawalsForm = () => import('@/pages/partners/partnersWithdrawals/form.vue')
const partnersWithdrawalsShow = () => import('@/pages/partners/partnersWithdrawals/show.vue')

const routes = [
  // partners routes
  {
    path: 'partners',
    name: 'partners',
    component: partnersIndex
  },
  {
    path: 'partners/create',
    name: 'partnersCreate',
    component: partnersForm
  },
  {
    path: 'partners/:id/edit',
    name: 'partnersEdit',
    component: partnersForm
  },
  {
    path: 'partners/:id',
    name: 'partnersShow',
    component: partnersShow
  },

  // partners deposits routes
  {
    path: 'partnersDeposits',
    name: 'partnersDeposits',
    component: partnersDepositsIndex
  },
  {
    path: 'partnersDeposits/create',
    name: 'partnersDepositsCreate',
    component: partnersDepositsForm
  },
  {
    path: 'partnersDeposits/:id/edit',
    name: 'partnersDepositsEdit',
    component: partnersDepositsForm
  },
  {
    path: 'partnersDeposits/:id',
    name: 'partnersDepositsShow',
    component: partnersDepositsShow
  },

  // partners withdrawals routes
  {
    path: 'partnersWithdrawals',
    name: 'partnersWithdrawals',
    component: partnersWithdrawalsIndex
  },
  {
    path: 'partnersWithdrawals/create',
    name: 'partnersWithdrawalsCreate',
    component: partnersWithdrawalsForm
  },
  {
    path: 'partnersWithdrawals/:id/edit',
    name: 'partnersWithdrawalsEdit',
    component: partnersWithdrawalsForm
  },
  {
    path: 'partnersWithdrawals/:id',
    name: 'partnersWithdrawalsShow',
    component: partnersWithdrawalsShow
  }
]

export default routes
